import React from 'react';
// import CompletedEventSliders from '../AdminMeeupEvents/LiveMeetUp/CompletedEventSliders/CompletedEventSliders';

import AdminAuditionNav from './AdminAuditionNav/AdminAuditionNav';
import CompleteAuditionSlider from './CompleteAuditionSlider/CompleteAuditionSlider';

const AdminAudition2 = () => {
    return (
        <>
            <AdminAuditionNav />

            <div className="card card-bg mt-3 py-2">
                <div className="d-flex px-4 pt-3">
                    <div className="faTrophy"><i className="fas fa-trophy"></i></div>
                    <h4 className="mx-3 text-white p-2">Complete Auditions</h4>
                </div>

                <div className="">
                    <CompleteAuditionSlider />
                </div>

            </div>
        </>
    );
};

export default AdminAudition2;